import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import { getEnvironment } from '@demo-system/commons/service/environment'

import { INITIAL_DATA_QUERY } from 'config/operations'
import A from 'services/analytics'
import { getAuthRedirectUrl } from 'services/environment'

export const INITIAL_STATE = {
  features: [],
}

const RootContext = createContext(INITIAL_STATE)

const RootContextProvider = (props) => {
  const { loading, error, data } = useQuery(INITIAL_DATA_QUERY, { variables: { environment: getEnvironment() } })

  const features = data?.features ? data.features.map((f) => f.name) : []
  const user = data?.me

  // Force login for anonymous and technical user
  if (['anonymous', 'helium'].includes(user?.id)) {
    window.location = getAuthRedirectUrl()
  }

  // Trigger Launch event only once, when user becomes defined
  if (user?.id && !A.getUser()) {
    window['DSN'].currentUser = user
    A.setUser(user.id)
    A.triggerToolStart()
  }

  const value = { loading, error, features, user }

  return <RootContext.Provider value={value}>{props.children}</RootContext.Provider>
}

const RootContextConsumer = RootContext.Consumer

export { RootContext, RootContextProvider, RootContextConsumer }
